import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Tree from '../ui/tree/tree';
import Node from '../ui/tree/node';
import UserNode from './userNode';
import {getUserChildren,} from 'actions';

class UserTree extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'UserTree';
    }

    render() {
    	let children = this.props.users.proxy_children || this.props.users.children
    	if(children) {
    	var parseUsers = () => {
    		var _self = this;
            let userTree = {
                user : this.props.users.proxy_account || this.props.users.user,
                children : []
            }
            var userTreeArray = [];

            for(let i = 0; i < children.length; i++) {
            	if(children[i].user.parents) {
	            	var index = children[i].user.parents.length - 1;
	              if(index > -1) {
	                if(userTreeArray[index])
	                    userTreeArray[index].push(children[i]);
	                else
	                    userTreeArray[index] = [children[i]];
	              }
	            }
	            else
	            	debugger
            }

            userTreeArray.forEach((item, index) => {
                item.forEach(child => {
                    if(child.user.parents.length == 0)
                        userTree.children.push(child);
                    else {
                        var childPointer = userTree.children;
                        child.user.parents.forEach((parent, index) => {
                            for (var i = childPointer.length - 1; i >= 0; i--) {
                                if(childPointer[i].user._id == parent) {
                                    childPointer = childPointer[i].children;
                                    break;
                                }
                            };
                        });
                        childPointer.push({...child, children : []})
                    }
                });
            });

            return userTree;
        }

        var tree = parseUsers();

        var generateTree = (node) => {
          return (
          	<div key={node.user._id}>
            	<Node  node={<UserNode user={node.user} />}>
                {node.children.map((child) => {
                    return generateTree(child);
                })}
	            </Node>
            </div>
          )
        }
        var dom = generateTree(tree);

        return (
        	<div id='user-tree-container'>	
	        	<Tree>{dom}</Tree>
        	</div>
        )
    }
    else
    	return <div></div>
  }
}

export default connect(({users}) => ({users}))(UserTree);



// WEBPACK FOOTER //
// ./src/browser/components/users/userTree.js